import styled from 'styled-components';

import { sectionStyle } from '../../utils';

export const Container = styled.section<{ $background?: string }>`
  ${sectionStyle({ width: 1280, margin: false })}
  flex-direction: column;
  position: relative;
  align-items: center;
  padding: 24px 8px;
  background-image: ${({ $background }) => ($background ? `url(${$background})` : 'none')};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 0 0;
`;

export const Inner = styled.div`
  max-width: 810px;
  width: 100%;
`;

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.common.PRIMARY};
`;

export const SubTitle = styled.div`
  p {
    font-size: 16px;
    line-height: normal;
    color: ${({ theme }) => theme.palette.common.PRIMARY};
    margin-top: 16px;
    margin-bottom: 16px;
  }

  strong {
    font-weight: 500;
  }
`;
